module.exports = {
  path: ':reference/overstay',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/MyBookingOverstay'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/my_bookings/routes/overstay/index.js